/* eslint-disable */
// This is a placeholder for local builds.
// The real aws-exports.js is generated during CDK deployment.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:953baa04-5907-42dc-8922-7ffe7d211218",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_b13Wm0ff1",
    "aws_user_pools_web_client_id": "3ku7aub5j5aep8b69oh7qoihi7",
    "oauth": {
        "domain": "creditnote25652a02-prod.auth.ap-southeast-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://creditnote.ext.youfoodz.engineering/",
        "redirectSignOut": "https://creditnote.ext.youfoodz.engineering/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": ["EMAIL"],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": ["TOTP"],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": ["EMAIL"],
    "aws_appsync_graphqlEndpoint": "https://hx543folsjcmpb7cjl4i7nlccy.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
    "aws_user_files_s3_bucket": "yf-credit-note-stack-lineitemuploadsbucket1603aa4f-ugh3ekuqyejg",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};

export default awsmobile;
